module.exports = __webpack_public_path__ + "static/media/skiaspen.8956dead.png";